import { RequestContext } from "../request-context";
import { WatchlistArgs } from "./watchlist";
import { LibraryArgs } from "./library";
import { DVString } from "./shared";

export interface MyStuffFeatureContent {}

export enum MyStuffViewType {
    WatchlistMyStuffView = 'watchlist',
    LibraryMyStuffView = 'library',
    ErrorMyStuffView = 'error'
}

export enum MyStuffFeatureType {
    LegacyWatchlistMyStuffFeature = 'legacy-watchlist',
    LegacyLibraryMyStuffFeature = 'legacy-library',
    ErrorMyStuffFeature = 'error',
    PartialErrorWarningMyStuffFeature = 'partial-error-warning'
}

export interface MyStuffViewArgs {
    watchlist?: WatchlistArgs;
    library?: LibraryArgs;
    shared: SharedInput;
}

export interface SharedInput {
    isPurchaseRow: boolean;
}

export interface MyStuffInput {
    context: RequestContext;
    viewType: MyStuffViewType;
    args: MyStuffViewArgs;
}

export interface MyStuffViewOutput {
    viewType: MyStuffViewType;
    features: MyStuffFeatureContentMap;
}

export type MyStuffFeatureContentMap = {
    [key in MyStuffFeatureType]?: MyStuffFeatureContent
}

export interface ErrorContent extends MyStuffFeatureContent {
    message: DVString;
}

export interface MyStuffOutput {
    viewOutput: MyStuffViewOutput
}
